import { BaseRepository } from "@/repositories/base-repository"
import type { IInstructionFeedbackActivityProduct } from "@/interfaces/api/instruction-feedback-activity-product.interface"

export class InstructionFeedbackActivityProductRepository extends BaseRepository<IInstructionFeedbackActivityProduct> {
  protected resourcePath = "planning/instruction-feedbacks-activities-products"
}
